
import axios from '../config/axios';

export const url = '/api/formulariocontactanos3lmag'


export const customcreartuvj1_676339f09ccea34376cf813a = ({
  correov6gp1l,
	nombreo31bw,
	telefono71bhf,
	cuentanostuideakfptok,

}) => new Promise((resolve, reject) => {
  if (correov6gp1l && nombreo31bw && telefono71bhf && cuentanostuideakfptok) {
    axios.post(`${url}/custom/creardatosformulario`, {
      correov6gp1l,
			nombreo31bw,
			telefono71bhf,
			cuentanostuideakfptok,

    },
    ).then((res) => {
      if (res.data.status === 'success') {
        resolve(res.data);
      } else {
        reject(res.data); 
      }
    }).catch((error) => {
      reject(error?.response?.data);
    });
  } else {
    reject({
      status: 'error',
      info: 'Verifique los parametros requeridos',
    });
  }
});



